import { useMemo } from 'react';

import cookieStorage from 'helpers/cookieStorage';
import { findCampaignTrialDays } from 'helpers/pricingPages';
import { getUtmParamsFromCookie } from 'helpers/utm';

import useDefaultTrialDays from './useTrialDays';

const getCrossTeamCampaignTrial = () => {
  const utmParamsFromCookie = getUtmParamsFromCookie();

  return (
    findCampaignTrialDays(utmParamsFromCookie?.utm_campaign) ||
    findCampaignTrialDays(utmParamsFromCookie?.b2b_special_plan) ||
    findCampaignTrialDays(utmParamsFromCookie?.cross_team_campaign) ||
    null
  );
};

const useSubscriptionPlans = (): {
  maxTrialDuration: number;
} => {
  const { defaultTrialDays } = useDefaultTrialDays();

  const maxTrialDuration = useMemo(() => {
    const trialDays =
      cookieStorage.getItem('TRIAL_DAYS') || getCrossTeamCampaignTrial();

    if (trialDays && !isNaN(Number(trialDays))) {
      return Number(trialDays);
    } else {
      return defaultTrialDays;
    }
  }, [defaultTrialDays]);

  return {
    maxTrialDuration,
  };
};

export default useSubscriptionPlans;
